import React from 'react';

function Dots(props) {
  console.log('Key is', props.key);
  console.log('Card in focus', props.cardInFocus);
  return props.key == props.cardInFocus ? (
    <div
      style={{
        height: 12,
        width: 12,
        borderRadius: 7,
        borderWidth: 2,
        borderColor: '#fff',
        borderStyle: 'solid',
        marginLeft: 2,
        marginRight: 2,
        marginHorizontal: 2,
      }}
    />
  ) : (
    <div
      style={{
        height: 8,
        width: 8,
        borderRadius: 5,
        backgroundColor: '#fff',
        marginHorizontal: 2,
        marginLeft: 2,
        marginRight: 2,
      }}
    />
  );
}

export default Dots;



// WEBPACK FOOTER //
// ./src/features/my-account/MainTabsBodyMyAccount/components/Dots.js